import A11yDialog from 'a11y-dialog';

export default function emailSignup() {

  const el = $( '.newsletter-modal' )[0];
  // Instantiate a new A11yDialog module
  const dialog = new A11yDialog( el );

  // Click on a menu item that links to #email-sign-up
  $( 'a[href="#email-sign-up"]' ).on( 'click', function( e ) {
    e.preventDefault();
    dialog.show()
  });

  $( '.footer-newsletter__sign-up-btn' ).click( function( e ) {
    dialog.show();
    const emailAddress = $('.footer-newsletter__email-input').val();
    $('.newsletter-modal #emailAddress').val( emailAddress );
  });

  

  dialog.on( 'show', function ( dialogEl, event ) {
    window.scrolledToView = true;
  });

  dialog.on( 'hide', function( dialogEl, event ) {
    document.cookie = "shownNewsletterModal=true";
  });

  if ( $( 'body' ).hasClass( 'home' ) ) {
    scrollShowModal( dialog );
  }
}

function scrollShowModal( dialog ) {
  window.scrolledToView = false;
  const documentHeight = jQuery( document ).height() - jQuery( window ).innerHeight();

  if ( document.cookie.split( ';' ).some( ( item ) => item.trim().startsWith( 'shownNewsletterModal=' ) ) ) {
    var newsLetterShown = true;
  }

  $( window ).scroll( function( e ) {
    if ( false === window.scrolledToView && newsLetterShown !== true && emailSignupSettings.enabled  ) {
      // After % scroll, show Newsletter Signup modal.
      if ( window.pageYOffset >= documentHeight * emailSignupSettings.showAfterPercentScrolled ) {
        dialog.show();
      }
    }
  });
}